





































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';

type GQLAttachment = {
  id: string | null;
  signedBlobId: string | null;
  fileName: string | null;
  contentType: string | null;
  url: string | null;
  size: number | null;
}

type Attachment = File | GQLAttachment;

interface IFilePreview {
  file: Attachment;
  isImage: boolean;
  icon: string;
  name: string;
  url: string;
  size: string;
}

const FILE_TYPES_ICONS: {[key: string]: string} = {
  'application/pdf': 'file-pdf',
  'text/csv': 'file-csv',
  'image/tiff': 'file-image',
};

@Component({})
export default class SUpload extends Vue {
  @Prop({ type: Array, default: null }) private files!: Array<Attachment> | null;

  private previews: IFilePreview[] = [];

  // When something happens on the outside (file is removed/added, etc),
  // we should not generate previews again for each file if we already
  // did generate url for file, etc, because it makes an ugly screen flicker.
  // This is why we will cache previews per files.
  // And also, performance, yeah
  private previewCache: Map<Attachment, IFilePreview> = new Map();

  @Watch('files', { deep: true, immediate: true })
  private setPreviews() {
    if (!this.files) {
      this.previews = [];
      return;
    }

    this.previews = [];

    this.files.forEach(file => {
      const cached = this.previewCache.get(file);
      if (cached) {
        this.previews.push(cached);
        return;
      }

      const preview = this.generatePreview(file);
      this.previews.push(preview);
      this.previewCache.set(file, preview);
    });
  }

  private generatePreview(file: Attachment): IFilePreview {
    const isImage = (type: string) => type.startsWith('image/') && type !== 'image/tiff';

    const preview: IFilePreview = {
      file,
      isImage: false,
      icon: 'file',
      name: '...',
      url: '...',
      size: '...',
    };

    if ('signedBlobId' in file) {
      preview.name = file.fileName!;
      preview.url = file.url!;
      preview.icon = FILE_TYPES_ICONS[file.contentType!] || 'file';
      preview.isImage = isImage(file.contentType!);
      preview.size = file.size ? this.formatFileSize(file.size) : '';
    } else {
      preview.name = file.name;
      preview.url = URL.createObjectURL(file);
      preview.icon = FILE_TYPES_ICONS[file.type] || 'file';
      preview.isImage = isImage(file.type);
      preview.size = this.formatFileSize(file.size);
    }

    return preview;
  }

  private formatFileSize(sizeInBytes: number) {
    const sizeInKB = sizeInBytes / 1024;

    if (sizeInKB >= 1024) {
      return `${(sizeInKB / 1024).toFixed(1)} MB`;
    } else {
      return `${sizeInKB.toFixed(1)} KB`;
    }
  }
}
